// ABOUTME: The white question cloud of screen 5B: a BETTER QUESTION eyebrow over the storm's question.
// ABOUTME: Plain text on the white cloud with the shared cloud ink, so it is never conveyed by color or imagery alone.

import { useContext, useState } from 'react';
import { Typography } from '@mui/material';
import CloudBlob from '../../crossing/CloudBlob';
import { QuestionArrivalContext } from '../../crossing/questionArrival';
import { useCrossingReducedMotion } from '../../crossing/useReducedMotion';
import { CROSSING_CLOUD_WHITE, CROSSING_CLOUD_INK } from '../../../../theme/crossingTokens';

const LINE_FADE = (delaySec: number) => ({
  '@keyframes qbLineIn': { from: { opacity: 0 }, to: { opacity: 1 } },
  animation: `qbLineIn 0.6s ease ${delaySec}s both`,
});

export default function QuestionBlob({ question, arrival }: { question: string; arrival?: boolean }) {
  const inherited = useContext(QuestionArrivalContext);
  const reducedMotion = useCrossingReducedMotion();
  // Read once at mount, as TierArrows does, so a later settle never starts the fade mid-screen.
  const [fade] = useState((arrival ?? inherited) && !reducedMotion);
  return (
    <CloudBlob color={CROSSING_CLOUD_WHITE} maxWidth={300} minWidth={260}>
      <Typography data-testid="better-question-eyebrow" sx={{ fontSize: '11px', fontWeight: 800, letterSpacing: '1.4px', color: CROSSING_CLOUD_INK, textTransform: 'uppercase', mb: 1, ...(fade ? LINE_FADE(0.45) : {}) }}>
        BETTER QUESTION
      </Typography>
      <Typography data-testid="better-question-text" sx={{ fontFamily: 'Newsreader, serif', fontSize: '16px', fontWeight: 600, color: CROSSING_CLOUD_INK, lineHeight: 1.3, ...(fade ? LINE_FADE(0.6) : {}) }}>
        {question}
      </Typography>
    </CloudBlob>
  );
}
